var isProd = import.meta.env.PROD;
var APP_ENV = isProd ? 'CF_APP_ENV' : 'local';
var API_URL = isProd ? 'CF_API_URL' : import.meta.env.VITE_APP_API_URL;
var AUTH_DOMAIN = isProd ? 'CF_AUTH_DOMAIN' : 'https://auth-qa.syf.com';
var FEATURE_FLAG_URL = isProd
    ? 'CF_FEATURE_FLAG_URL'
    : 'https://dev.synchronycredit.com/assets/';
var config = {
    APP_ENV: APP_ENV,
    API_URL: API_URL,
    AUTH_DOMAIN: AUTH_DOMAIN,
    FEATURE_FLAG_URL: FEATURE_FLAG_URL
};
export default config;
//# sourceMappingURL=config.js.map